import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { workforceSolutionsFeatureKey, reducer } from './workforce-solutions.reducer';
import { WorkforceSolutionsEffects } from './effects/workforce-solutions.effects';
import { EnvironmentProviders } from '@angular/core';

export const provideWorkforceSolutionsStore = (): EnvironmentProviders[] => [
    provideState(workforceSolutionsFeatureKey, reducer),
    provideEffects(WorkforceSolutionsEffects)
];
